const OveviewChart = {
    series: [{
        type: 'area',
        name: 'Faturado',
        data: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47]
    }, {
        type: 'area',
        name: 'Elaboração',
        data: [28, 41, 52, 42, 13, 18, 29, 18, 36, 51, 55, 35]
    }, {
        type: 'line',
        name: 'Confirmado',
        data: [45, 52, 38, 24, 33, 65, 45, 75, 54, 18, 28, 10]
    }],
    chartOptions: {
        chart: {
            height: 240,
            type: 'line',
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: 2,
            dashArray: [0, 0, 3]
        },
        fill: {
            type: 'solid',
            opacity: [0.15, 0.05, 1],
        },
        xaxis: {
            categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        },
        colors: ['#3ceb36', '#eab905', '#50a5f1'],
    }
};

const activitiesData = [
    {
        id: '#SK3215',
        date: '03 Mar, 2023',
        type: '30/60',
        currency: 'Produto Testes 0001',
        amount: '1 kg',
        usd: '9.067,62'
    },
    {
        id: '#SK3216',
        date: '04 Mar, 2023',
        type: '30/60',
        currency: 'Produto Testes 0099',
        amount: '1 kg',
        usd: '9.067,62'
    },
    {
        id: '#SK3217',
        date: '05 Mar, 2023',
        type: '30/60/90',
        currency: 'Produto Testes 0001',
        amount: '1 kg',
        usd: '9.067,62'
    },
    {
        id: '#SK3218',
        date: '03 Mar, 2023',
        type: '30/60',
        currency: 'Produto Testes 0888',
        amount: '1 kg',
        usd: '2.123,01'
    },

]

export { OveviewChart, activitiesData };
